import { createAction, props } from '@ngrx/store';
import { IndividualPEP, BeneficialOwnerPEP, CreateIndividualManualPepCheck } from 'src/app/modules/pep-list/pep-list.interface';

export const setPEPList = createAction(
  '[Pep List Component] Set PEP List',
  props<{ individualPepList: IndividualPEP[]; beneficialOwnerPEPList: BeneficialOwnerPEP[] }>()
);

export const clearPepList = createAction('[Pep List Component] Clear PEP List');

// Requests

export const loadPEPList = createAction('[Api/Request Pep List] Load PEP List');
